export default {
  allAssets: 'All assets',
  zeroAssets: '0 assets are selected',
  assets: 'assets',
};
